














































import { Component, Vue, Prop } from "vue-property-decorator";
import BatchImportVue from "../components/app/BatchImport.vue";
import BatchAccounterVue from "../components/app/BatchAccounter.vue";
import BusinessCirclesVue from "../components/app/BusinessCircles.vue";
import UploadChargeVue from "../components/app/UploadCharge.vue";
import UploadToolVue from "../components/app/UploadTool.vue";
import AccounterImportVue from "../components/app/AccounterImport.vue";

export interface Tool {
    icon: string;
    text: string;
    color: string;
    fontColor: string;
    operation: Function;
    emoji?: string;
}

@Component({
    components: {
        BatchImport: BatchImportVue,
        BatchAccounter: BatchAccounterVue,
        BusinessCircles: BusinessCirclesVue,
        AccounterImport: AccounterImportVue,
        UploadCharge: UploadChargeVue,
        "upload-tool": UploadToolVue
    }
})
export default class SystemTool extends Vue {
    showBatchImport = false;
    batchAccounter = false;
    businessCircles = false;
    showCharge = false;
    showAccounter = false;
    AccounterImport = false;
    isTax: boolean = false
    toolList: Tool[] = [
        {
            icon: "el-icon-s-tools",
            text: "open dev tool",
            color: "#fbb64b",
            fontColor: "#fefef7",
            operation: this.openDevTool,
            emoji: "🔧"
        },
        {
            icon: "el-icon-odometer",
            text: "open memory ball",
            color: "#00cbe8",
            fontColor: "#7ad3dd",
            operation: this.openMemBall,
            emoji: "⚗"
        },
        {
            icon: "el-icon-picture",
            text: "change theme",
            color: "#ff7281",
            fontColor: "#feeff0",
            operation: this.changeTheme,
            emoji: "🎨"
        },
        {
            icon: "el-icon-upload",
            text: "batch import",
            color: "#ffce49",
            fontColor: "#feeff0",
            operation: this.toggleBatchImport,
            emoji: "🗃"
        },
        {
            icon: "el-icon-upload",
            text: "add accounting",
            color: "#8c628c",
            fontColor: "#feeff0",
            operation: this.batchImport,
            emoji: "✨"
        },
        {
            icon: "el-icon-upload",
            text: "business circles",
            color: "#ffce49",
            fontColor: "#feeff0",
            operation: this.businessImport,
            emoji: "📄"
        },
        {
            icon: "el-icon-upload",
            text: "upload charge",
            color: "#ffce49",
            fontColor: "#feeff0",
            operation: this.chargeImport,
            emoji: "📈"
        },
        {
            icon: "el-icon-upload",
            text: "accounter import",
            color: "#ffce49",
            fontColor: "#feeff0",
            operation: this.accountImport,
            emoji: "📝"
        },
        {
            icon: "el-icon-upload",
            text: "taxation import",
            color: "#ffce49",
            fontColor: "#feeff0",
            operation: this.taxImport,
            emoji: "🗃"
        },
        {
            icon: "el-icon-upload",
            text: "taxation import",
            color: "#ffce49",
            fontColor: "#feeff0",
            operation: this.taxInfoImport,
            emoji: "⚡️"
        }
    ];

    openDevTool() {
        this.$utils.sendToElectron("open-dev-tool");
    }

    openMemBall() {
        this.$emit("showMemory");
    }

    changeTheme() {
        const app = <HTMLElement>document.querySelector("body");
        if (app.classList.contains("dark")) {
            app.classList.remove("dark");
        } else {
            app.classList.add("dark");
        }
    }

    toggleBatchImport() {
        this.showBatchImport = !this.showBatchImport;
    }

    batchImport() {
        this.batchAccounter = !this.batchAccounter;
    }
    businessImport() {
        this.businessCircles = !this.businessCircles;
    }
    chargeImport() {
        this.isTax = false
        this.showCharge = !this.showCharge;
    }
    accounterImport() {
        this.showAccounter = !this.showAccounter;
    }
    accountImport() {
        this.AccounterImport = !this.AccounterImport;
    }
    taxImport() {
        this.isTax = true
        this.showCharge = !this.showCharge;
    }

    taxInfoImVisible = false;
    taxInfoImport() {
        this.taxInfoImVisible = true;
    }
}
